import { ProductsTable } from '@/components/features/products/ProductsTable'

export const Products = () => {
  return <ProductsTable />
}
